// src/pages/navratri/NavratriHome.jsx
import React from 'react';

const NavratriHome = () => {
  return (
    <div style={{ padding: '2rem' }}>
      <h1>Navratri Home</h1>
      <p>This is a placeholder page for the Navratri (Hindu Religion Festival) module.</p>
    </div>
  );
};

export default NavratriHome;